<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	import upprocess from '../../../../common/upProcess/index.vue'
	import uploadFile from '../../../../common/uploadFile/index.vue'
	import updateywkm from '../../../../common/updateywkm/index.vue'
	import {
		importExcel,
		getSubjectCompanys,
		getMappingPageListByRule,
		getDetailById,
		updateMapping,
		clearMapping,
		saveMapping,
		checkMapping
	} from '../../../../../api/home.js'
	import config from '../../../../../../configHttp.js'
	export default {
		name: '',
		components: {
			upprocess,
			uploadFile,
			updateywkm
		},
		data: function() {
			return {
				upformdata: {}, //文件信息
				importType: "0", //模板类型
				mboptions: getdata().mboptions,
				companydata: [],
				uptype: 1,
				companydiag: false,
				choosecompanyindex: 0,
				ywdiag: false,
				batchNum: "",
				nowcompany: "",
				headData: getdata().headData,
				pagination: getdata().pagination,
				sort: "",
				order: "",
				ywdiag: false,
				ywtitle: "",
				mapping: {},
				relations: [],
				tableData: [],
				successdata:{},
				timer:null,
				count: 5,
				viewErrorStatus:"0",
				tablekey:0,
				sourceFlagData: []
			};
		},
		created() {},
		
		methods: {
			// 上传
			getuploadparams(e) { //获取上传文件流
				this.upformdata = e
			},
			fordownloadmb() { //标准模板下载
				//简单下载，交给浏览器去做处理
				let params = {
        downUrl: config.baseURL + "/balance/dowloadTemplate",
        typeObj: {
						toForm: true,
						fileType: "xlsx",
						failUrl:this.$winURl
					},
					params:{},
      	};
      	this.$downloadcommon(params);
			},
			forkm() {
				if (this.$emptyandnull(this.upformdata.upfile)) {
					this.$message.error("请选择要上传的文件")
					return false
				}
				let formData = {
					importType: this.importType,
					file: this.upformdata.upfile
				};
				importExcel(formData).then(res => {
					if (res.data.code == 1) {
						//如果成功数量为0则跳转至结果页面
						if(res.data.data.successCount == 0){
							this.$message.error("当前导入文件成功条数为0，具体错误信息可到上传结果界面查看")
						} else {
							this.uptype = 2
							this.batchNum = res.data.data.batchNo
							this.getSubjectCompanys()
						}
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			//新增编辑
			forupdateywkm(row) {
				getDetailById({
					id: row.id
				}).then(res => {
					if (res.data.code == 1) {
						this.relations = res.data.data.relations
						this.mapping = res.data.data.mapping
						this.mapping.batchNum = this.batchNum
						this.ywtitle = "编辑业务科目"
						this.ywdiag = true;
						let sourceArr = JSON.parse(JSON.stringify(this.$sourceFlagMapping));
						sourceArr.map((item,index)=>{
							if(item.value === '5' && this.mapping.sourceFlag != '5')
							sourceArr.splice(index,1);
						});
						this.sourceFlagData = sourceArr;
					}

				})
			},
			foraddywkm() {
				this.mapping = {}
				this.mapping.batchNum = this.batchNum
				this.ywtitle = "新增业务科目"
				this.relations = [];
				this.sourceFlagData = this.$sourceFlagMapping;
				this.ywdiag = true;
			},
			
			getywkmForm(data) {
				let subjectCodeArr = [];
      			subjectCodeArr.push(data.mapping.companySubjectCode);
				let formula = "("+data.mapping.companySubjectCode+")";
				if(data.relations.length > 0) {
					for (let i = 0; i < data.relations.length; i++) {
						let relation =  data.relations[i];
						formula+=relation.formula;
						formula+="("+relation.companySubjectCode+")";
						subjectCodeArr.push(relation.companySubjectCode);
					}
				}
				data.mapping.formula = formula;
				data.mapping.subjectCodes = subjectCodeArr.join(",");
				if (this.ywtitle == "新增业务科目") {
					data.mapping.ruleNum=this.nowcompany.ruleNum
					data.mapping.ruleId=this.nowcompany.ruleId
					saveMapping(data).then(res => {
						if(res.data.code==1){
							this.$message.success("新增成功")
							this.ywdiag = false
							this.getMappingPageListByRule()
						}
					})
				}else{
					updateMapping(data).then(res=>{
						if(res.data.code==1){
							this.$message.success("编辑成功")
							this.ywdiag = false
							this.getMappingPageListByRule()
						}
					})
				}
			},
			//清除映射
			cleanYs(){
				var chooseitem = this.$refs.tablebox.getSelectionval()
				if(this.$emptyandnull(chooseitem)){
					this.$message.warning("请先进行列表勾选");
					return;
				}
				clearMapping({
					ids:chooseitem.map(item=>item.id).join(",")
				}).then(res=>{
					if(res.data.code==0){
						this.$message.success("清除成功")
						this.getMappingPageListByRule()
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			// 表格查询
			getMappingPageListByRule(param) {
				let params = {
					ruleId: this.nowcompany.ruleId,
					sourceFlag:1
					// companyCode:this.nowcompany.companyCode
				}
				params.current = this.pagination.pageNum
				params.size = this.pagination.pageSize
				params.sort = this.sort
				params.order = this.order
				getMappingPageListByRule(params).then(res => {
					if(param){
						this.companydiag = true
					}
					this.pagination.total = res.data.data.total
					this.tableData = res.data.data.records
				})
			},
			sortchange(data) {
				this.sort = data.prop
				this.order = data.order == "ascending" ? 'asc' : 'desc'
				this.getMappingPageListByRule()
			},
			sizechange(e) {
				this.pagination.pageSize = e
				this.getMappingPageListByRule()
			},
			currentChange(e) {
				this.pagination.pageNum = e
				this.getMappingPageListByRule()
			},
			//选择公司
			forchooseNsrmc() {
				if (this.choosecompanyindex == null) {
					this.$message.error("请选择公司")
					return false
				}
				this.nowcompany = this.companydata[this.choosecompanyindex]
				this.companydiag = false;
				//查询结果：
				this.getMappingPageListByRule()
			},
			forchoosecompany() {
				this.getSubjectCompanys('companydiag')
				// this.choosecompanyindex=null
			},
			//获取公司列表
			getSubjectCompanys(param) {
				getSubjectCompanys({
					batchNum: this.batchNum
				}).then(res => {
					this.companydata = res.data.data
					this.nowcompany = this.companydata[0]||{
						ruleNum:"",
						nsrmc:""
					}
					//对结果判断  this.viewErrorStatus
					// this.companydata.forEach(item=>{
					// 	if(item.status == '1'){
					// 		this.viewErrorStatus = '1'
					// 	}
					// });
					this.getMappingPageListByRule(param)
				})
			},
			//选择公司
			
			//提交
			forsubmit() {
				checkMapping({
					batchNum: this.batchNum
				}).then(res=>{
					if(res.data.code==1){
						if(res.data.data.errorMsg!=''){
							this.$message.error(res.data.data.errorMsg);
							return;
						}
						this.successdata=res.data.data
						let self=this;
						if (self && !self._isDestroyed) {
						  this.timer = setInterval(() => {
							  this.count--
							  if(self._isDestroyed){
								  clearInterval(this.timer);
								  return false
							  }
							  if(this.count==0){
								  this.$refs['uploadfileRef'].forrefresh()
								  this.uptype=1
								   clearInterval(this.timer);
							  }
						  }, 1000)
						}
						this.uptype = 3
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			forbackup(){
				this.$refs['uploadfileRef'].forrefresh()
				this.uptype=1
				 clearInterval(this.timer);
			},
			forchooseindex(index){
					this.$emit("forchooseindex",index)
			},
			forback() {
				this.uptype = 1
			},
			
			closediag() {
				this.ywdiag = false
			},
			//跳转至自定义模板
			toCustomTemplate () {
				this.$router.push("/CustomTemplate")
			}
		}
	};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
